import { find } from 'lodash';
import './index.scss'
$(".select-button").click(function() {
    $(".select").show()
    $(".select-model").show()
})